import React, { useCallback, useMemo, useState } from "react";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import { LANGUAGES, LANGUAGES_MENU } from "../../../i18n/config";
import i18next from "i18next";
import { AiFillCheckCircle } from "react-icons/ai";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { closeLanguagePop } from "../../../redux/action/member/memberAction";
import { useTranslation } from "react-i18next";
import {
  AbsoluteCenter,
  Box,
  Flex,
  Grid,
  GridItem,
  Icon,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { COMMON_WEB_PATH } from "../../../constant";

const LanguagePage = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const i18n_common = (key) => t(`common.${key}`);

  const modalBg = useColorModeValue("light.100", "#1A2036");
  const boxBg = useColorModeValue("light.200", "dark.250");
  const itemHoverBg = useColorModeValue("light.300", "dark.300");
  const textActiveColor = useColorModeValue("dark.100", "light.100");

  const website_language = window.web_language || [];

  const memberData = useSelector((state) => state.isMemberInfo);
  const { test } = memberData || {};

  const language_filter = useMemo(() => {
    return LANGUAGES_MENU?.filter((item) => {
      if (test == 1) {
        return item;
      } else {
        return website_language?.includes(item.value);
      }
    });
  }, [LANGUAGES_MENU, test, website_language]);
  const onClose = async () => {
    await dispatch(closeLanguagePop());
  };

  const dispatch = useDispatch();
  return (
    <Modal
      variant={`brandPrimary`}
      onClose={onClose}
      isOpen={true}
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent
        width={{
          md: "450px",
          base: "90%",
        }}
        minW={{
          base: "90%",
          md: "500px",
        }}
        height={{
          base: "520px",
        }}
        borderRadius={{
          base: "common",
        }}
        borderTopRadius={{
          md: "none",
        }}
        borderBottomRadius={{
          md: "common",
        }}
        shadow="md"
        bgImage={`url(${COMMON_WEB_PATH}/theOne/lng/lng_background.png) !important`}
        bg={`url(${COMMON_WEB_PATH}/theOne/lng/lng_background.png) !important`}
        bgSize="100% 100% !important"
        bgPosition="center"
        pb="10px"
        pt="50px"
        px="20px"
        position="relative"
      >
        <Box
          onClick={onClose}
          position="absolute"
          top="10px"
          right="10px"
          w={{
            base: "30px",
            md: "40px",
          }}
          h={{
            base: "20px",
            md: "20px",
          }}
          cursor="pointer"
        >
          <Image w="100%" src={`${COMMON_WEB_PATH}/theOne/lng/lng_close.png`} />
        </Box>
        <ModalBody
          bgImage={`url(${COMMON_WEB_PATH}/theOne/lng/lng_background_inner.png)`}
          bgSize="100% 100%"
          bgPosition="center"
          bgRepeat="no-repeat"
          h={500}
          px="0"
          overflow="scroll"
        >
          <Grid
            templateColumns={
              language_filter?.length < 5
                ? "repeat(1, minmax(0, 1fr))"
                : {
                    base: "repeat(1, minmax(0, 1fr))",
                    md: "repeat(2, minmax(0, 1fr))",
                  }
            }
            as="section"
            display="grid"
            flexDirection={`column`}
            gap="10px"
            //borderRadius={`common`}
            py="8px"
            px="8px"
          >
            {language_filter?.map((item, index) => {
              return (
                <GridItem>
                  <Box
                    onClick={async (event) => {
                      event.stopPropagation();
                      await i18next.changeLanguage(item.value);
                      localStorage.setItem("i18nextLng", item.value);
                      // const targetPath = item.value === "tw" ? "" : item.value;
                      const targetPath = item.value;

                      window.location.assign("/" + targetPath);
                    }}
                    key={`${item.language}-${index}`}
                    cursor={`pointer`}
                    //borderRadius={`common`}
                    p="10px"
                    px="10px"
                    display="flex"
                    flexDirection={`row`}
                    alignItems={`center`}
                    justifyContent={`center`}
                    sx={{
                      bgImage: `${COMMON_WEB_PATH}/theOne/lng/lng_button.png`,
                      bgSize: "100%100%",
                      bgPos: "center",
                      bgRepeat: "no-repeat",
                    }}
                    position="relative"
                    gap="20px"
                  >
                    <Flex
                      alignItems={`center`}
                      justifyContent={"space-between"}
                      gap="15px"
                      w="100%"
                    >
                      <Image
                        w="38px"
                        h="auto"
                        src={`https://flagsapi.com/${item.flag?.toUpperCase()}/flat/64.png`}
                      />
                      <Flex
                        className="text-overflow"
                        flex={1}
                        alignItems={`center`}
                        gap="5px"
                      >
                        <Tooltip label={item.text}>
                          <Text
                            className="text-overflow"
                            fontWeight={`medium`}
                            fontSize="25px"
                            color={textActiveColor}
                          >
                            {item.text}
                          </Text>
                        </Tooltip>
                      </Flex>
                      <Box
                        w="30px"
                        h="30px"
                        bgImage={`url(${COMMON_WEB_PATH}/theOne/lng/lng_checkbox.png)`}
                        bgSize="100%100%"
                        position={"relative"}
                      >
                        {i18next.language === item.value && (
                          <AbsoluteCenter>
                            <Image
                              src={`${COMMON_WEB_PATH}/theOne/lng/lng_tick.png`}
                              minW="28px"
                            />
                          </AbsoluteCenter>
                        )}
                      </Box>
                    </Flex>
                  </Box>
                </GridItem>
              );
            })}
          </Grid>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default LanguagePage;
